export default "__VITE_ASSET__e7107790__"